import type { SVGProps } from 'react';

const BlueArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1593_23718)">
      <path
        d="M8.00016 2.66683L7.06016 3.60683L10.7802 7.33349L2.66683 7.33349L2.66683 8.66683L10.7802 8.66683L7.0535 12.3868L8.00016 13.3335L13.3335 8.00016L8.00016 2.66683Z"
        fill="#3A78FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1593_23718">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BlueArrowRight;
